
define('template!pimProductFilterValueItemTpl', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="pim-filter-value">\n  <label class="pim-checkbox-label">\n    <input type="checkbox" class="cbx-select" ' +
((__t = ( selected?'checked':'')) == null ? '' : __t) +
'>\n    <span class="pim-checkbox-text">' +
((__t = ( value )) == null ? '' : __t) +
'</span>\n  </label>\n</div>\n';

}
return __p
};});

